@if (currentBenefits) {
  <div class="mb-3">
    <mwp-card-benefit-summary
      [header]="'Current Benefits'"
      [deductionsHeader]="'Current Deductions -'"
      [benefitSummaryList]="currentBenefits"
      [displayCategoryColumn]="true"
      [displayBenefitColumn]="true"
      [enableToggle]="true" />
  </div>
}
@if (enrollmentRequests && displayBenefitRequests) {
  <div class="mb-3">
    <mwp-card-benefit-summary
      [header]="'Benefit Requests'"
      [deductionsHeader]="'Benefit Request Deductions -'"
      [benefitSummaryList]="enrollmentRequests"
      [displayCategoryColumn]="true"
      [displayBenefitColumn]="true"
      [enableToggle]="true" />
  </div>
}